import { Typography, TypographyProps } from '@mui/material';

type Props = TypographyProps;

export function FieldError({ sx, children, ...props }: Props) {
  if (!children) return null;

  return (
    <Typography
      {...props}
      sx={{
        color: '#D92D20',
        fontSize: '12px',
        lineHeight: '16px',
        mt: '2px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}
